export default function handleSkinToneMap() {
  const skinToneMap = [
    { value: 'black-cherry', label: 'Ayo-Oluwa', icon: 'https://cdn.shopify.com/s/files/1/0562/6442/5517/files/ayo.png?v=1649419555' },
    //{ value: 'dark-warm-brown', label: 'Damarys' },
    { value: 'ginger', label: 'Jalyn', icon: 'https://cdn.shopify.com/s/files/1/0562/6442/5517/files/jalyn.png?v=1649419555' },
    { value: 'pearl', label: 'Jennifer', icon: 'https://cdn.shopify.com/s/files/1/0562/6442/5517/files/jennifer.png?v=1649419555' },
  ];

  return skinToneMap;
}
